import { ViewTreeNode } from '../../models/view.tree-node';
import { ColorRecipeModel } from 'src/app/edit/models/color-recipe.model';
import { Patch } from 'src/vendor/immer-6.0.9/compat/pre-3.7/dist/immer';


export type ObjectId = string;


export interface NodeState {
  objectId: ObjectId;

  // the node should be visible, assuming nothing occludes it.
  shown: boolean;
  shownSetByTween: boolean;


  // selected means that this node is under examination from the user
  // a context label can be applied to a selected node.
  selected: boolean;

  // checked means that the node is highlighted
  // multiple nodes can be checked, only 1 can be selected.
  checked: boolean;

  pickable: boolean;
  paint: ColorRecipeModel;
}

export class EngineNodesStateModel {
  nodeState: Record<string, Record<ObjectId, NodeState>>;
  patches: Patch[];
  patchesForChapter: Record<string, Patch[]>;
  activeChapterId: string;
}
